import React from "react";
import { Phone, Mail } from "lucide-react";
import SectionShell from "./SectionShell";

const BOOKING_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ02YajSQ8YV7BYbb2l-R-VtO4aWh4mSpHaSaV2-1mvwsjIR8CMPDXY1zlSXB11mIXxeq-dMz0zS?gv=true";

const EXPECT = [
  "60 minutes, by phone or video",
  "A plain-English read on your current coverage",
  "No obligation and no follow-up pressure",
];

export default function Booking() {
  return (
    <SectionShell
      id="contact"
      eyebrow="Book a consultation"
      variant="elevated"
      data-testid="booking"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-4">
          <h2 className="font-display text-[#0B1F3F] text-4xl sm:text-5xl tracking-tight leading-[1.08]">
            Pick a time that suits you.
          </h2>
          <p className="text-[#5A6476] text-base md:text-lg leading-relaxed mt-5">
            Choose a slot for a Confidence Review with Biagio. You'll get a
            calendar invite instantly.
          </p>
          <ul className="mt-8 border-t border-[#E6E2D8]">
            {EXPECT.map((e) => (
              <li key={e} className="py-3.5 border-b border-[#E6E2D8] text-[15px] text-[#0F1B2D]">
                {e}
              </li>
            ))}
          </ul>
          <div className="mt-8 space-y-3 text-sm">
            <a href="tel:+14165550102" className="flex items-center gap-3 text-[#0B1F3F] hover:text-[#8A6A2E] transition-colors" data-testid="booking-phone">
              <Phone size={15} /> +1 (416) 555-0102
            </a>
            <a href="mailto:info@prosperafinancial.ca" className="flex items-center gap-3 text-[#0B1F3F] hover:text-[#8A6A2E] transition-colors" data-testid="booking-email">
              <Mail size={15} /> info@prosperafinancial.ca
            </a>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="rounded-2xl overflow-hidden bg-white border border-[#E6E2D8] shadow-[0_30px_60px_-30px_rgba(11,31,63,0.2)]">
            <iframe
              src={BOOKING_URL}
              title="Book a consultation with Biagio DiGirolamo"
              className="block w-full h-[760px] md:h-[600px]"
              style={{ border: 0 }}
              loading="lazy"
              data-testid="booking-calendar-iframe"
            />
          </div>
          <a
            href={BOOKING_URL.replace("?gv=true", "")}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary mt-3"
            data-testid="booking-open-new-tab"
          >
            Open the booking page in a new tab
          </a>
        </div>
      </div>
    </SectionShell>
  );
}
